<template>
  <div>
    <div class="row">
      <div v-for="(data, id) in datas" :key="id" class="col-12">
        <div class="card card_grey mb_12">
          <div class="d-flex justify-content-between align-items-center">
            <div class="d-flex align-items-center">
              <div>
                <apexchart
                  height="90"
                  width="90"
                  type="radialBar"
                  :options="female.chartOptions"
                  :series="[data.value]"
                ></apexchart>
              </div>
              <div>
                <div class="sub_title_2">
                  {{ data.metricName }} ({{ data.currency }})
                </div>
                <div class="d-flex align-items-center">
                  <div class="data_text">{{ data.value }}%</div>
                  <div
                    class="d-inline-flex align-items-center"
                    :class="
                      data.achievementStatus == 'UP'
                        ? 'badge_green'
                        : 'badge_red'
                    "
                  >
                    <IconSvg
                      :color="data.achievementStatus == 'UP' ? 'green' : 'red'"
                      :type="
                        data.achievementStatus == 'UP'
                          ? 'chart_up'
                          : 'chart_down'
                      "
                    />
                    <div
                      class="data_detil"
                      :class="
                        data.achievementStatus == 'UP'
                          ? 'text_green'
                          : 'text_red'
                      "
                    >
                      <span v-if="data.achievementStatus == 'UP'">+</span
                      >{{ data.achievement }}%
                    </div>
                  </div>
                  <div class="d-flex ms-2">
                    <div
                      class="d-inline-flex align-items-center me-2"
                      :class="
                        data.trendStatus == 'UP' ? 'badge_green' : 'badge_red'
                      "
                    >
                      <IconSvg
                        :color="data.trendStatus == 'UP' ? 'green' : 'red'"
                        :type="
                          data.trendStatus == 'UP' ? 'arrow_up' : 'arrow_down'
                        "
                      />
                      <div
                        class="data_detil"
                        :class="
                          data.trendStatus == 'UP' ? 'text_green' : 'text_red'
                        "
                      >
                        <span v-if="data.trendStatus == 'UP'">+</span
                        >{{ data.trend }}%
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <button
                class="naked_button"
                @click="onShowModalRatio('female', data)"
              >
                <img src="@/assets/images/a/chart_icon.svg" />
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="col-12">
        <div class="card card_grey mb_12">
          <div class="d-flex justify-content-between align-items-center">
            <div class="d-flex align-items-center">
              <div>
                <apexchart ref="chart" height="90" width="90" type="radialBar" :options="millennial.chartOptions"
                  :series="[data.millenial_value]"></apexchart>
              </div>
              <div>
                <div class="sub_title_2">millennial Ratio</div>
                <div class="d-flex align-items-center">
                  <div class="data_text">{{ data.millenial_value }}%</div>
                  <div class="d-flex ms-2">
                    <div class="d-inline-flex align-items-center me-2"
                      :class="data.millenial_trend_status == 'UP' ? 'badge_green' : 'badge_red'">
                      <IconSvg :color="data.millenial_trend_status == 'UP' ? 'green' : 'red'"
                        :type="data.millenial_trend_status == 'UP' ? 'arrow_up' : 'arrow_down'" />
                      <div class="data_detil" :class="data.millenial_trend_status == 'UP' ? 'text_green' : 'text_red'">
                        <span v-if="data.millenial_trend_status == 'UP'">+</span>{{ data.millenial_trend }}%
                      </div>
                    </div>
                    <div class="d-inline-flex align-items-center"
                      :class="data.millenial_achievement_status == 'UP' ? 'badge_green' : 'badge_red'">
                      <IconSvg :color="data.millenial_achievement_status == 'UP' ? 'green' : 'red'"
                        :type="data.millenial_achievement_status == 'UP' ? 'chart_up' : 'chart_down'" />
                      <div class="data_detil"
                        :class="data.millenial_achievement_status == 'UP' ? 'text_green' : 'text_red'">
                        <span v-if="data.millenial_achievement_status == 'UP'">+</span>{{ data.millenial_achievement }}%
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <button class="naked_button" @click="onShowModalRatio('millennial', data.millenial_value)">
                <img src="@/assets/images/a/chart_icon.svg" />
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="card card_grey">
          <div class="d-flex justify-content-between align-items-center">
            <div class="d-flex align-items-center">
              <div>
                <apexchart height="90" width="90" type="radialBar" :options="digital.chartOptions"
                  :series="[data.digital_value]"></apexchart>
              </div>
              <div>
                <div class="sub_title_2">Digital Talent Ratio</div>
                <div class="d-flex align-items-center">
                  <div class="data_text">{{ data.digital_value }}%</div>
                  <div class="d-flex ms-2">
                    <div class="d-inline-flex align-items-center me-2"
                      :class="data.digital_trend_status == 'UP' ? 'badge_green' : 'badge_red'">
                      <IconSvg :color="data.digital_trend_status == 'UP' ? 'green' : 'red'"
                        :type="data.digital_trend_status == 'UP' ? 'arrow_up' : 'arrow_down'" />
                      <div class="data_detil" :class="data.digital_trend_status == 'UP' ? 'text_green' : 'text_red'">
                        <span v-if="data.digital_trend_status == 'UP'">+</span>{{ data.digital_trend }}%
                      </div>
                    </div>
                    <div class="d-inline-flex align-items-center"
                      :class="data.digital_achievement_status == 'UP' ? 'badge_green' : 'badge_red'">
                      <IconSvg :color="data.digital_achievement_status == 'UP' ? 'green' : 'red'"
                        :type="data.digital_achievement_status == 'UP' ? 'chart_up' : 'chart_down'" />
                      <div class="data_detil"
                        :class="data.digital_achievement_status == 'UP' ? 'text_green' : 'text_red'">
                        <span v-if="data.digital_achievement_status == 'UP'">+</span>{{ data.digital_achievement }}%
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <button class="naked_button" @click="onShowModalRatio('digital', data.digital_value)">
                <img src="@/assets/images/a/chart_icon.svg" />
              </button>
            </div>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import IconSvg from "@/components/IconSvg.vue";

export default {
  props: ["load", "datas", "chart_digital"],
  components: {
    IconSvg,
  },

  mounted() {
    // this.digital.series = [this.data.digital_value];
  },

  data() {
    return {
      modal: null,
      modalRatio: {
        show: false,
        load: false,
      },
      dataRatio: {},
      female: {
        series: [this.datas.value],
        chartOptions: {
          chart: {
            type: "radialBar",
          },
          plotOptions: {
            radialBar: {
              hollow: {
                size: "45%",
              },
              dataLabels: {
                name: {
                  show: false,
                },
                value: {
                  show: false,
                },
              },
              track: {
                background: "#E4E4E4",
              },
            },
          },
          grid: {
            padding: {
              top: 0,
              right: 0,
              bottom: 0,
              left: 0,
            },
          },
          stroke: {
            lineCap: "round",
          },
          labels: [""],
          // colors: ["#E91E63"],
          colors: ["#2E93fA"],
        },
      },
      millennial: {
        series: [this.datas.value],
        chartOptions: {
          chart: {
            type: "radialBar",
          },
          plotOptions: {
            radialBar: {
              hollow: {
                size: "45%",
              },
              dataLabels: {
                name: {
                  show: false,
                },
                value: {
                  show: false,
                },
              },
              track: {
                background: "#E4E4E4",
              },
            },
          },
          grid: {
            padding: {
              top: 0,
              right: 0,
              bottom: 0,
              left: 0,
            },
          },
          stroke: {
            lineCap: "round",
          },
          labels: [""],
          colors: ["#2E93fA"],
        },
      },
      digital: {
        series: [0],
        chartOptions: {
          chart: {
            type: "radialBar",
          },
          plotOptions: {
            radialBar: {
              hollow: {
                size: "45%",
              },
              dataLabels: {
                name: {
                  show: false,
                },
                value: {
                  show: false,
                },
              },
              track: {
                background: "#E4E4E4",
              },
            },
          },
          grid: {
            padding: {
              top: 0,
              right: 0,
              bottom: 0,
              left: 0,
            },
          },
          stroke: {
            lineCap: "round",
          },
          labels: [""],
          colors: ["#2E93fA"],
        },
      },
    };
  },

  methods: {
    onShowModalRatio(type, data) {
      this.modalRatio.show = true;
      this.dataRatio = {
        year: "2024",
        type: data.metricId.includes("FEMALE")
          ? "female"
          : data.metricId.includes("MILENNIAL")
          ? "millennial"
          : "digital",
        title: data.metricId.includes("FEMALE")
          ? "FEMALE RATIO"
          : data.metricId.includes("MILENNIAL")
          ? "MILLENNIAL RATIO"
          : "DIGITAL TALENT RATIO",
        percen: data,
      };
    },
    onCloseModalRatio(value) {
      this.modalRatio.show = value;
    },
  },

  // computed: {
  //   chartDigital() {
  //     return this.data.digital_value
  //   }
  // },

  // watch: {
  //   "chartDigital"() {
  //     if (this.chartDigital) {

  //     }
  //   }
  // }
};
</script>

<style scoped>
.chart-container {
  width: 40px;
  height: 40px;
}
</style>
